import { apiClient } from '../../services/apiClient';
import type { Tag, CreateTagPayload, UpdateTagPayload } from './types';

/**
 * タグ一覧を取得
 */
export async function listTags(): Promise<Tag[]> {
  const { data } = await apiClient.get<Tag[]>('/tags');
  return data;
}

/**
 * タグを作成
 */
export async function createTag(payload: CreateTagPayload): Promise<Tag> {
  const { data } = await apiClient.post<Tag>('/tags', payload);
  return data;
}

/**
 * タグを更新
 */
export async function updateTag(tagId: string, payload: UpdateTagPayload): Promise<Tag> {
  const { data } = await apiClient.put<Tag>(`/tags/${tagId}`, payload);
  return data;
}

/**
 * タグを削除
 */
export async function deleteTag(tagId: string): Promise<void> {
  await apiClient.delete(`/tags/${tagId}`);
}
